/* eslint-disable vue/valid-v-for */

<template>
<!-- // 热门股单-风口 -->
  <page-frame class="tuyere-wrap" :dataRefreshDate="dataRefreshDate" ref="pageFrame">
   
      <div class="head-card">
        <div class="head">
          <img v-if="logoUrl" class="img" :src="logoUrl" alt="">
          <img v-else-if="defaultLogoUrl" class="img" :src="defaultLogoUrl" alt="">
          <div v-else class="img" :style="{background: defaultColor}">{{defaultLogoName}}</div>
          <div class="txt">
            <h1 class="tit">{{tuyereName}}</h1>
          </div>
        </div>
        <p class="header-des">{{tuyereDesc}}</p>
        <table cellpadding="0" cellspacing="0" class="head-table">
          <thead>
            <tr>
              <th>{{t('tuyere.head.txt_1')}}</th>
              <th>{{t('tuyere.head.txt_2')}}</th>
              <th>{{t('tuyere.head.txt_3')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in mainStkList" :key="item.stkRank">
              <td @click="toMarket(item)">
                <label :class="`label-market ${labelFormate(item.stkCode)}`">{{labelFormate(item.stkCode)}}</label>{{item.stkName}}
              </td>
              <td>{{item.price}}</td>
              <td :class="[!item.range ? 'grey' :Number(item.range) > 0 ? 'corange' : 'cgreen']">
                {{$filters.rangeFilter(item.range)}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 概念列表 -->
      <div class="concept-box">
        <template v-if="subModuleList.length">
          <div class="concept-list" v-for="(item, conceptIdx) in subModuleList" :key="conceptIdx">
            <h2 class="tit">{{item.subModuleName}}</h2>
            <p class="des" v-if="(item.subModuleDesc||'').length > 20">{{item.subModuleDesc}}</p>
            <div class="main-stock-box">
              <!-- 股票列表 -->
              <ul class="main-stock-ul">
                <li
                  class="main-stock-list"
                  v-for="(itemStk, itemStkIdx) in item.subModuleStkList"
                  :key="itemStkIdx"
                  v-show="(subModuleList.length === 1 || item.isUnfold || item.subModuleStkList.length < 7) ? item.subModuleStkList : itemStkIdx < 3"
                >
                <!-- v-show="(item.isUnfold || item.subModuleStkList.length < 7) ? item.subModuleStkList : itemStkIdx < 3" -->
                  <span class="sp"  @click="toMarket(itemStk)"><label :class="`label-market ${labelFormate(itemStk.stkCode)}`">{{labelFormate(itemStk.stkCode)}}</label>{{itemStk.stkName}}</span>
                  <span class="sp">{{itemStk.price}}</span>
                  <span class="sp" :class="[!itemStk.range ? 'grey' : Number(itemStk.range) > 0 ? 'corange' : 'cgreen']">
                    {{$filters.rangeFilter(itemStk.range)}}
                  </span>
                </li>
              </ul>
              <a
                href="javascript:;"
                class="change-mainsotck-state corange"
                @click="changeMainStockState(conceptIdx)"
                v-if="item.subModuleStkList.length >= 7 && subModuleList.length > 1"
              >
                {{item.isUnfold ? t('tuyere.concept.txt_1') : t('tuyere.concept.txt_2', { num: item.subModuleStkList.length - 3 })}}
              </a>
            </div>
          </div>
        </template>
        <p v-if="!subModuleList.length" class="nodata">{{t('tuyere.nodata')}}</p>
        <p class="foot">{{t('tuyere.foot_1')}}</p>
        <p class="foot">{{t('tuyere.foot_2')}}<a class="link corange" href="javascript:;" @click="toJumpUrl">{{t('tuyere.foot_3')}} <i class="iconfont icon-choose"></i></a></p>
      </div>
    <!-- </div> -->
   
  </page-frame>
</template>

<script>
import PageFrame from '@/components/PageFrame/index.vue'

import { useI18n } from 'vue-i18n'
import { reactive, onMounted, ref,toRefs, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import apiOther from '@/api/modules/api-other'
import userAgent from '@/utils/ua-parser.js'
import { getMarketLabl } from '@/utils/security-tools.js'
import { timestampToTime } from '@/utils/date.js'
export default {
  name: 'Tuyere',
  components: {
    PageFrame
  },
  setup() {
    // const store = useStore()
    let pageFrame = ref(null)
    const { t } = useI18n()
    const route = useRoute()
    const data = reactive({
      logoUrl: '', // 风口logo
      defaultLogoUrl:'',
      defaultColor: '', // 默认logo颜色
      defaultLogoName: '', // 默认logo名字
      tuyereName: '', // 风口名称
      tuyereDesc: '', // 风口说明
      mainStkList: [], // 主股票信息
      subModuleList: []
    })
    let  dataRefreshDate = ref('')


    onMounted(() => {
      getData()
      document.title = t('tuyere.title')
    })

    // 获取热门股单风口信息
    const getData = async () => {
      let params = {
        id: route.query.id
      }
      let res = await apiOther.getTuyereDetail(params)
      if(res) {
        for(let key in data) {
          data[key] = res[key] || ''
        }
        data.subModuleList.forEach((item) => {
          item['isUnfold'] = false
        })
        dataRefreshDate.value = timestampToTime(Date.now(),'YYYY-MM-DD hh:mm:ss')
      }
    }

    //
    const labelFormate = (data)=>{
      return getMarketLabl(data)
    }

    //跳转股票详情请
    const toMarket = (item) => {
      console.log('item--', item)
      if(userAgent.isApp()) {
        const params = {
          stockType: item.stype,
          stockCode: item.stkCode,
          stockName: item.stkName,
        }
        window.JFSTOCK.jumpPage({
          name:'market',
          data:params
        })
      }
    }


    const changeMainStockState = (index) => {
      data.subModuleList[index].isUnfold = !data.subModuleList[index].isUnfold
      nextTick(()=>{
        pageFrame.value?.refreshScroll()
      })
      
    }

    //跳转免责声明
    const toJumpUrl = () => {
      let url = window.DISCLAIMERS_URL
      if(userAgent.isApp()) {
        const obj = {
          url: url,
          bottomTab: false, // 是否需要底部导航栏  //仅限于首页
          backHeader: true, // 是否需要后退按钮
          isFresh: false, // 是否下拉可刷新
          elasticBorder: true, // 是否弹性边框        //针对IOS
          isCloseBtn: true, // 是否关闭按钮
          isNeedHeader: true, // 是否需要头部
          isNewPage: true
        }
        window.JFSTOCK.jumpUrl(obj)
        return
      }
      window.location.href = url
    }

    return {
      t,
      pageFrame,
      dataRefreshDate,
      ...toRefs(data),
      changeMainStockState,
      toJumpUrl,
      toMarket,
      labelFormate,
      getData
    }
  }
}
</script>

<style lang="stylus">
@import './style.styl'
</style>
